import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b7f1e72"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "LEI Registrierung", -1))
const _hoisted_2 = { class: "right" }
const _hoisted_3 = { class: "step-heading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.stepHeading), 1)
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.stepHeading), 1)
  ], 64))
}